export function keepUserDataLocalStorage({user, token}) {
  localStorage.setItem('access_token', token);

  for(const k in user) {
    localStorage.setItem(k, user[k]);
  }
}